import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class AppSubscriptionShareVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppsubscriptionshareCreateany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppsubscriptionshareReadany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareRead,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppsubscriptionshareDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareDelete,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAppsubscriptionshareUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareUpdate,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationAppsubscriptionshareCreateany,
        PermissionAttributesEnum.GlobalOperationAppsubscriptionshareUpdateany,
        PermissionAttributesEnum.GlobalOperationAppsubscriptionshareDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareCreate,
        PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareUpdate,
        PermissionAttributesEnum.ContextClientOperationAppsubscriptionshareDelete,
      ],
    });
  };
}
